export default "__VITE_ASSET__D$XfL7XR__"